import _ from 'lodash';
import { useContext, useEffect, useMemo, useState } from "react";
import { PapsContext } from "../PapsContext";
import { createRefPath_client, createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import { _appUserPresenceCollection } from 'global/cnr/reducers/AppUserReducer';
import { _showAppLogs, LogContext } from '../LogContext';
import { _cacheGroupTypes } from './useTimestamp';
import { useCachedData } from './useCachedData';
import { where } from 'firebase/firestore';

const dbCallTypes = {
  appProfiles: 'appProfiles',
  appUsersSnapshot: 'appUsersSnapshot',
  clientProfiles: 'clientProfiles',
  appUsersPresence: 'appUsersPresence',
};

export const useAppUsersInfo = () => {

  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext
  const { pathViews } = paps_state ?? {}
  const { events: eventKey } = pathViews ?? {}

  const [appUserSnapshot, setAppUserSnapshot] = useState()
  const [appUsersPresense, setAppUsersPresense] = useState()
  const [clientProfiles, setClientProfiles] = useState()

  useCachedData({
    cache_groupType: _cacheGroupTypes.appUsersInfo,
    cache_key: eventKey,
    fetchers: [
      { key: dbCallTypes.appProfiles, getConfigFn: getConfig_clientProfile },
      { key: dbCallTypes.appUsersSnapshot, getConfigFn: getConfig_appUserSnapshot },
      { key: dbCallTypes.clientProfiles, getConfigFn: getConfig_clientProfileGallery },
      { key: dbCallTypes.appUsersPresence, getConfigFn: getConfig_getAppUserPresence },
    ],
    updateLocalState: (data) => {
      _.forEach(data, (value, key) => {
        switch (key) {
          case dbCallTypes.appProfiles:
            console.log('value', value)
            break;
          case dbCallTypes.appUsersSnapshot:
            setAppUserSnapshot(value);
            break;
          case dbCallTypes.clientProfiles:
            // console.log('dbCallTypes.clientProfiles', data?.clientProfiles)
            setClientProfiles(data?.clientProfiles);
            break;
          case dbCallTypes.appUsersPresence:
            setAppUsersPresense(data);
            break;
        }
      });
    }
  })


  // ------------------- Memoized stable return -------------------
  const appUsersInfo = useMemo(
    () => ({ appUserSnapshot, clientProfiles, appUsersPresense }),
    [appUserSnapshot, clientProfiles, appUsersPresense]
  );

  return appUsersInfo;

};


const getConfig_clientProfile = (pathViews, callback) => {
  const wheres = []
  wheres.push(where(`events.${pathViews.events}`, '!=', null))
  return {
    refPath: createRefPath_event(pathViews, ['profiles']),
    wheres,
    callback,
  }
};

/**
 * ['_appUserSnapshot']
 * @param {*} pathViews 
 * @param {*} callback 
 * @returns 
 */
const getConfig_appUserSnapshot = (pathViews, callback) => ({
  refPath: createRefPath_event(pathViews, ['_appUserSnapshot']),
  opts: { returnFirstObject: true, ignoreId: true, listen: true },
  callback,
});

/**
 * ['profileGallery', 'galleryItems']
 * @param {*} pathViews 
 * @param {*} callback 
 * @returns 
 */
const getConfig_clientProfileGallery = (pathViews, callback) => ({
  refPath: createRefPath_client(pathViews, ['profileGallery', 'galleryItems']),
  opts: { returnFirstObject: true, ignoreId: true, listen: true },
  callback,
});

const getConfig_getAppUserPresence = (pathViews, callback) => ({
  refPath: createRefPath_event(pathViews, [_appUserPresenceCollection]),
  opts: { ignoreId: true, listen: true },
  callback,
});

